import React from 'react';
import { commonStyles } from '../../styles/common';
import SectionHeading from '../ui/SectionHeading';
import PartnersCarousel from '../ui/PartnersCarousel';

const Partners = () => {
  return (
    <section className={`${commonStyles.section} bg-white`}>
      <div className={commonStyles.container}>
        <SectionHeading
          title="Nos Partenaires de Confiance"
          description="Ils ont fait confiance à notre expertise pour réaliser leurs projets d'économies d'énergie."
          centered
        />
        <PartnersCarousel />
      </div>
    </section>
  );
};

export default Partners;